import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import AllowanceService from "../../../../services/AllowanceService";

const AddAllowancesModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
}) => {
	const [formData, setFormData] = useState({
		name: "",
		fee: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const allowanceService = new AllowanceService();
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name: item?.name,
				fee: item?.fees,
			});
		}
	}, [item]);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			name: formData?.name,
			fees: formData?.fee,
		};

		setLoading(true);
		if (isAdd) {
			allowanceService
				.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success("Allowance Added Successfully");
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			allowanceService
				.update(formData?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success("Allowance Updated Successfully");
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addProduct" : "ar fade addProduct"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Header>
					<Modal.Title>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.allowances}
					</Modal.Title>
					<Button
						variant=""
						className="close"
						style={{
							right: lang === "en" ? "0" : "auto",
							left: lang === "ar" ? "0" : "auto",
						}}
						onClick={() => {
							setAddModal();
						}}>
						<span>&times;</span>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.name}
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({ ...formData, name: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.fees}
								type="number"
								placeholder={Translate[lang]?.fees}
								bsSize="lg"
								name="fee"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.fee}
								onChange={(e) =>
									setFormData({ ...formData, fee: e.target.value })
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={setAddModal} variant="danger light">
						{Translate[lang]?.close}
					</Button>
					<Button variant="primary" type="submit" disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddAllowancesModal;
